import desktopProductSearch from "./desktopProductSearch";

const { getDesktopProductSearchRank } = desktopProductSearch;

const normalize = (value) => String(value ?? "")
  .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  .replace(/đ/gi, "d").toLowerCase().trim().replace(/\s+/g, " ");
const compact = (value) => value.replace(/[^\p{L}\p{N}]/gu, "");

export const findProductSuggestions = (products, query, limit = 8, { desktop = false } = {}) => {
  const term = normalize(query);
  if (!term) return [];
  const tokens = term.split(" ");
  const compactTerm = compact(term);
  if (!compactTerm) return [];
  const seen = new Set();
  const matches = [];
  for (const product of products) {
    if (!product || product.id === undefined || product.id === null || typeof product.name !== "string" || !product.name.trim()) continue;
    const identity = `${product.id}:${product.unit || ""}`;
    if (seen.has(identity)) continue;
    seen.add(identity);
    const code = normalize(product.id);
    if (!code) continue;
    if (desktop) {
      const score = getDesktopProductSearchRank(product, term);
      if (score !== null) matches.push({ product, score, index: matches.length });
      continue;
    }
    const name = normalize(product.name);
    const barcode = normalize(product.barcode);
    const text = `${name} ${code} ${barcode}`;
    const [compactName, compactCode, compactBarcode] = [name, code, barcode].map(compact);
    const compactFields = [compactName, compactCode, compactBarcode];
    if (!tokens.every((token) => text.includes(token) || compactFields.some((field) => field.includes(compact(token))))
      && !compactFields.some((field) => field.includes(compactTerm))) continue;
    const score = code === term || barcode === term ? 0
      : name === term || compactName === compactTerm ? 1
      : code.startsWith(term) ? 2
      : name.startsWith(term) || compactName.startsWith(compactTerm) ? 3
      : tokens.every((token) => name.split(" ").some((word) => word.startsWith(token))) ? 4 : 5;
    matches.push({ product, score, index: matches.length });
  }
  return matches.sort((a, b) => a.score - b.score || a.index - b.index)
    .slice(0, limit).map((match) => match.product);
};

// Keep remote matches that use server-side aliases, after the locally recognized matches.
export const sortDesktopProductSearchResults = (products, query) => products
  .map((product, index) => ({ product, index, rank: getDesktopProductSearchRank(product, query) ?? 4 }))
  .sort((a, b) => a.rank - b.rank || a.index - b.index)
  .map(({ product }) => product);

// Web only: the browser cache may hold just the categories already opened, so
// show local matches first and append API matches it does not have yet. Local
// lines win on duplicates because they carry the store's own prices.
export const mergeProductSearchResults = (localResults = [], remoteResults = []) => {
  const seen = new Set(localResults.map((product) => String(product.id)));
  return [...localResults, ...remoteResults.filter((product) => !seen.has(String(product.id)))];
};
